package com.essntl.features.itinerary.ui.edit_itinerary_service

import core.validation.Form
import core.validation.field.DateRangeField
import core.validation.field.Field
import core.validation.field.TimeRangeField
import core.validation.validator.DateDoubleValidator
import core.validation.validator.DateRangeValidator
import core.validation.validator.TimeDoubleValidator

class EditItineraryServiceValidation {
    val editItineraryServiceForm = EditItineraryServiceForm()
}

class EditItineraryServiceForm : Form() {
    val dateRange =
        DateRangeField(
            validators =
            arrayOf(
                DateDoubleValidator(
                    firstValueRequired = true,
                ),
                DateRangeValidator(
                    firstValueRequired = true,
                ),
            ),
        )

    val timeRange =
        TimeRangeField(
            validators =
            arrayOf(
                TimeDoubleValidator,
            ),
        )

    override val fields: List<Field>
        get() = listOf(
            dateRange,
            timeRange,
        )
}